export const checkIsMobile = () => {
  const isMobileRegex = new RegExp('Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile', 'i');
  return isMobileRegex.test(navigator.userAgent);
};
